export const ROUTES = {
  EXPIRED_INVITATION: '/invitation-expired',
  TRIAL: '/trial',
  TRIAL_START: '/trial/start',
  TRIAL_SIGNUP: '/trial/signup',
  LOGIN: '/login',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
};
